/**
 * Phase 3B.4 — Central Admin license issue/renew request & response contracts.
 * Activation codes appear only on successful mutation responses (never on GET).
 */
export const LICENSE_PRODUCTS = ['Quds Pharmacy POS', 'Quds Supermarket POS'];
//# sourceMappingURL=license-operations.js.map